import React from 'react';
import { Box, ColumnLayout } from '@amzn/awsui-components-react';
import { useTranslation } from 'react-i18next';

import { BulkUploadAccountingStrings, DownloadAccountingStrings } from 'modules/accountingStrings/components';
import { useReports } from 'modules/reports/hooks';

export const BulkEditAccountingStrings = () => {
    const { t } = useTranslation('bulkEdit');
    const { createInProgress, createReportAsync, uploadInProgress, uploadReportAsync, report } = useReports();

    return (
        <>
            <div>
                <Box variant="h1">{t('bulkEditCoa')}</Box>
            </div>
            <br />
            <ColumnLayout columns={2}>
                <div>
                    <Box variant="h3">{t('bulkEditCoaDownload')}</Box>
                    <br />
                    <DownloadAccountingStrings
                        createInProgress={createInProgress}
                        createReportAsync={createReportAsync}
                        report={report}
                    />
                </div>
                <div>
                    <Box variant="h3">{t('bulkEditCoaUpload')}</Box>
                    <br />
                    <BulkUploadAccountingStrings
                        uploadInProgress={uploadInProgress}
                        uploadReportAsync={uploadReportAsync}
                        report={report}
                    />
                </div>
            </ColumnLayout>
        </>
    );
};
